import { onlineListener } from "online-listener";
import { ReplaySubject } from "rxjs";

export const rxjsOnlineObservable = onlineListener;
